import Vue from 'vue'

export default new Vue({
    methods:{
        cleanInputSearch(){
            this.$emit('clean-input')
        },
        onCleanInputSearch(callback){
            this.$on('clean-input',callback)
        },
        showPrintOptions(){
          this.$emit('print-options')
        },
        onShowPrintOptions(callback){
          this.$on('print-options',callback)
        },
        confirmPrint(){
          this.$emit('confirm-print')
        },
        onConfirmPrint(callback){
          this.$on('confirm-print',callback)
        },
        deleteEvent(){
          this.$off("confirm-print");
        }
    }
})
